import axios from 'axios'
import {createStore} from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {setAuthInHeader} from "@/api";
import shotUrlStore from "@/store/shotUrl";
import payStore from "@/store/pay";

export default createStore({
    state: {
        authInfo: {
            name : null,
            phoneNumber : null,
            token: null,
        }
    },
    mutations: {
        setAuthInfo(state, authInfo) {
            state.authInfo = authInfo
            setAuthInHeader(authInfo.token)
        },
        setName(state, name) {
            state.authInfo.name = name
        },
        removeAuthInfo(state) {
            state.authInfo = {
                name: null,
                orderPhoneNumber: null,
                token: null,
            }
            setAuthInHeader(null)
        }
    },
    getters: {

    },
    actions: {
        setName: ({commit}, data) => {
            console.log('commit setName', data)
            commit('setName', data);
        },
        // 반대편(gilchkin)에서 발급한 YPTOKEN 쿠키만으로 로그인 복원
        bootstrap: ({commit, state}) => {
            return new Promise((resolve) => {
                if (state.authInfo && state.authInfo.token) {
                    resolve(state.authInfo)
                    return
                }
                axios.post('/api/auth/session', null, {headers: {"Content-Type": `application/json`}})
                    .then(result => {
                        const response = result.data
                        if (response && response.code === "J0000" && response.data && response.data.access_token) {
                            const authInfo = {
                                name: null,
                                phoneNumber: response.data.phone_number,
                                token: response.data.token_type + " " + response.data.access_token,
                            }
                            commit('setAuthInfo', authInfo)
                            resolve(authInfo)
                        } else {
                            resolve(null)
                        }
                    })
                    .catch(() => resolve(null))
            })
        },
        login:({commit}, data) => {
            return new Promise((resove, reject) => {
                axios.post('/api/auth/login', data, {headers: {
                        "Content-Type": `application/json`,
                    }})
                    .then(result => {
                        console.log('login', result.data)

                        const response = result.data
                        if (response.code === "J0000") {
                            console.log(response)
                            console.log(response.data.phone_number)
                            console.log(response.data.token_type)
                            console.log(response.data.access_token)

                            const authInfo = {
                                name: null,
                                phoneNumber: response.data.phone_number,
                                token : response.data.token_type + " " + response.data.access_token,
                            };
                            console.log(authInfo)
                            commit('setAuthInfo', authInfo);
                            resove(authInfo)
                        } else {
                            alert('인증코드를 다시한번 확인해주세요.')
                            resove()
                        }
                    })
                    .catch(error => {
                        console.error(error)
                        alert('인증코드를 다시한번 확인해주세요.')
                        reject(error)
                    })
            })
        },
        logout: ({commit}) => {
            //cartStore.dispatch('removeCartInfo').then(r => r)
            shotUrlStore.dispatch('removeRouterInfo').then(r => r)
            payStore.dispatch('removePayInfo').then(r => r)
            // 공유 쿠키(YPTOKEN)도 서버에서 삭제 → gilchkin까지 동시 로그아웃
            axios.post('/api/auth/logout').catch(() => {})
            commit('removeAuthInfo');
        }
    },
    modules: {},
    plugins: [
        // 공용 키 'vuex'는 common/cart/shotUrl store와 충돌(서로 덮어써 authInfo 유실)하므로 전용 키 사용
        createPersistedState({key: 'ypGilAuth'})
    ]
})